import React from 'react';
import { Timer } from 'lucide-react';
import { useTesterAvgTestTime } from '../../../hooks/analytics/useTesterReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/**
 * `tester_avg_time` — average days to complete a test, org-wide plus the
 * caller's own figure when it appears in the per-tester breakdown. v1 proxy
 * (`AVG(updated_at - created_at)` over completed runs) — see the backend's
 * code comment on `/api/analytics/tester/avg-test-time` for the caveat.
 */
export const TesterAvgTimeCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useTesterAvgTestTime();
  const topTester = data?.per_tester && data.per_tester.length > 0
    ? [...data.per_tester].sort((a, b) => a.avg_days - b.avg_days)[0]
    : null;

  return (
    <WidgetCard
      title="Average Test Time"
      description="Average days to complete a test (v1 proxy — created to updated timestamp)"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load average test time.'}
      isEmpty={!isLoading && !isError && !data}
      emptyMessage="No completed tests yet."
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="analytics-kpi-grid gap-3">
        <StatCard
          title="Avg. Days to Complete"
          value={data?.overall_avg_days != null ? data.overall_avg_days.toFixed(1) : '—'}
          icon={<Timer className="h-5 w-5" />}
          color="bg-blue-100 text-blue-600"
          subtitle="org-wide"
        />
        <StatCard
          title="Fastest Tester"
          value={topTester ? topTester.avg_days.toFixed(1) : '—'}
          color="bg-emerald-100 text-emerald-600"
          subtitle={topTester?.tester_name}
        />
      </div>
    </WidgetCard>
  );
};

export default TesterAvgTimeCard;
